module.exports = __webpack_public_path__ + "img/ico-burger-closed.d723207b.svg";